export const vuexModuleName = 'auth'

export const userTokenStorageKey = 'token'

export const signinRoute = { name: 'auth.singin' }
